// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/assert.proto

/* eslint-disable */

export const protobufPackage = "models";

/** AssertCategoryType defines an enumeration of assertion categories. */
export enum AssertCategoryType {
  /** ASSERT_CATEGORY_UNSPECIFIED - Invalid Assert Category type. */
  ASSERT_CATEGORY_UNSPECIFIED = 0,
  /** ASSERT_CATEGORY_FABRIC - Used for Fabric related assertion types */
  ASSERT_CATEGORY_FABRIC = 1,
  /** ASSERT_CATEGORY_UPSTREAM_PEERING - Used for Upstream Peering related assertion types. */
  ASSERT_CATEGORY_UPSTREAM_PEERING = 2,
  /** ASSERT_CATEGORY_HOST_ATTACHMENT - Used for Host Attachment related assertion types. */
  ASSERT_CATEGORY_HOST_ATTACHMENT = 3,
  /** ASSERT_CATEGORY_SERVICES - Used for Service related assertion types. */
  ASSERT_CATEGORY_SERVICES = 4,
  /** ASSERT_CATEGORY_COMPLIANCE - Used for Compliance related assertion types. */
  ASSERT_CATEGORY_COMPLIANCE = 5,
  /** ASSERT_CATEGORY_SECURITY - Used for Security related assertion types. */
  ASSERT_CATEGORY_SECURITY = 6,
  /** ASSERT_CATEGORY_DEVICE - Assert category is device. */
  ASSERT_CATEGORY_DEVICE = 7,
  /** ASSERT_CATEGORY_PORT - Assert category is port. */
  ASSERT_CATEGORY_PORT = 8,
  /** ASSERT_CATEGORY_NETWORK - Assert category is network. */
  ASSERT_CATEGORY_NETWORK = 9,
  /** ASSERT_CATEGORY_MULTISITE - Assert category is multisite. */
  ASSERT_CATEGORY_MULTISITE = 10,
  UNRECOGNIZED = -1,
}

export function assertCategoryTypeFromJSON(object: any): AssertCategoryType {
  switch (object) {
    case 0:
    case "ASSERT_CATEGORY_UNSPECIFIED":
      return AssertCategoryType.ASSERT_CATEGORY_UNSPECIFIED;
    case 1:
    case "ASSERT_CATEGORY_FABRIC":
      return AssertCategoryType.ASSERT_CATEGORY_FABRIC;
    case 2:
    case "ASSERT_CATEGORY_UPSTREAM_PEERING":
      return AssertCategoryType.ASSERT_CATEGORY_UPSTREAM_PEERING;
    case 3:
    case "ASSERT_CATEGORY_HOST_ATTACHMENT":
      return AssertCategoryType.ASSERT_CATEGORY_HOST_ATTACHMENT;
    case 4:
    case "ASSERT_CATEGORY_SERVICES":
      return AssertCategoryType.ASSERT_CATEGORY_SERVICES;
    case 5:
    case "ASSERT_CATEGORY_COMPLIANCE":
      return AssertCategoryType.ASSERT_CATEGORY_COMPLIANCE;
    case 6:
    case "ASSERT_CATEGORY_SECURITY":
      return AssertCategoryType.ASSERT_CATEGORY_SECURITY;
    case 7:
    case "ASSERT_CATEGORY_DEVICE":
      return AssertCategoryType.ASSERT_CATEGORY_DEVICE;
    case 8:
    case "ASSERT_CATEGORY_PORT":
      return AssertCategoryType.ASSERT_CATEGORY_PORT;
    case 9:
    case "ASSERT_CATEGORY_NETWORK":
      return AssertCategoryType.ASSERT_CATEGORY_NETWORK;
    case 10:
    case "ASSERT_CATEGORY_MULTISITE":
      return AssertCategoryType.ASSERT_CATEGORY_MULTISITE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertCategoryType.UNRECOGNIZED;
  }
}

export function assertCategoryTypeToJSON(object: AssertCategoryType): string {
  switch (object) {
    case AssertCategoryType.ASSERT_CATEGORY_UNSPECIFIED:
      return "ASSERT_CATEGORY_UNSPECIFIED";
    case AssertCategoryType.ASSERT_CATEGORY_FABRIC:
      return "ASSERT_CATEGORY_FABRIC";
    case AssertCategoryType.ASSERT_CATEGORY_UPSTREAM_PEERING:
      return "ASSERT_CATEGORY_UPSTREAM_PEERING";
    case AssertCategoryType.ASSERT_CATEGORY_HOST_ATTACHMENT:
      return "ASSERT_CATEGORY_HOST_ATTACHMENT";
    case AssertCategoryType.ASSERT_CATEGORY_SERVICES:
      return "ASSERT_CATEGORY_SERVICES";
    case AssertCategoryType.ASSERT_CATEGORY_COMPLIANCE:
      return "ASSERT_CATEGORY_COMPLIANCE";
    case AssertCategoryType.ASSERT_CATEGORY_SECURITY:
      return "ASSERT_CATEGORY_SECURITY";
    case AssertCategoryType.ASSERT_CATEGORY_DEVICE:
      return "ASSERT_CATEGORY_DEVICE";
    case AssertCategoryType.ASSERT_CATEGORY_PORT:
      return "ASSERT_CATEGORY_PORT";
    case AssertCategoryType.ASSERT_CATEGORY_NETWORK:
      return "ASSERT_CATEGORY_NETWORK";
    case AssertCategoryType.ASSERT_CATEGORY_MULTISITE:
      return "ASSERT_CATEGORY_MULTISITE";
    case AssertCategoryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AssertDeviceType defines an enumeration of assertion device types. */
export enum AssertDeviceType {
  /** ASSERT_DEVICE_UNSPECIFIED - Invalid AssertDeviceType type. */
  ASSERT_DEVICE_UNSPECIFIED = 0,
  /** ASSERT_DEVICE_SWITCH - Assert device is switch. */
  ASSERT_DEVICE_SWITCH = 1,
  /** ASSERT_DEVICE_SERVER - Assert device is server. */
  ASSERT_DEVICE_SERVER = 2,
  UNRECOGNIZED = -1,
}

export function assertDeviceTypeFromJSON(object: any): AssertDeviceType {
  switch (object) {
    case 0:
    case "ASSERT_DEVICE_UNSPECIFIED":
      return AssertDeviceType.ASSERT_DEVICE_UNSPECIFIED;
    case 1:
    case "ASSERT_DEVICE_SWITCH":
      return AssertDeviceType.ASSERT_DEVICE_SWITCH;
    case 2:
    case "ASSERT_DEVICE_SERVER":
      return AssertDeviceType.ASSERT_DEVICE_SERVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertDeviceType.UNRECOGNIZED;
  }
}

export function assertDeviceTypeToJSON(object: AssertDeviceType): string {
  switch (object) {
    case AssertDeviceType.ASSERT_DEVICE_UNSPECIFIED:
      return "ASSERT_DEVICE_UNSPECIFIED";
    case AssertDeviceType.ASSERT_DEVICE_SWITCH:
      return "ASSERT_DEVICE_SWITCH";
    case AssertDeviceType.ASSERT_DEVICE_SERVER:
      return "ASSERT_DEVICE_SERVER";
    case AssertDeviceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AssertSeverityType defines an enumeration of assertion severity types. */
export enum AssertSeverityType {
  /** ASSERT_SEVERITY_UNSPECIFIED - Invalid AssertSeverityType type. */
  ASSERT_SEVERITY_UNSPECIFIED = 0,
  /** ASSERT_SEVERITY_MAJOR - Assert severity is major (red). */
  ASSERT_SEVERITY_MAJOR = 1,
  /** ASSERT_SEVERITY_MINOR - Assert severity is minor (yellow). */
  ASSERT_SEVERITY_MINOR = 2,
  UNRECOGNIZED = -1,
}

export function assertSeverityTypeFromJSON(object: any): AssertSeverityType {
  switch (object) {
    case 0:
    case "ASSERT_SEVERITY_UNSPECIFIED":
      return AssertSeverityType.ASSERT_SEVERITY_UNSPECIFIED;
    case 1:
    case "ASSERT_SEVERITY_MAJOR":
      return AssertSeverityType.ASSERT_SEVERITY_MAJOR;
    case 2:
    case "ASSERT_SEVERITY_MINOR":
      return AssertSeverityType.ASSERT_SEVERITY_MINOR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertSeverityType.UNRECOGNIZED;
  }
}

export function assertSeverityTypeToJSON(object: AssertSeverityType): string {
  switch (object) {
    case AssertSeverityType.ASSERT_SEVERITY_UNSPECIFIED:
      return "ASSERT_SEVERITY_UNSPECIFIED";
    case AssertSeverityType.ASSERT_SEVERITY_MAJOR:
      return "ASSERT_SEVERITY_MAJOR";
    case AssertSeverityType.ASSERT_SEVERITY_MINOR:
      return "ASSERT_SEVERITY_MINOR";
    case AssertSeverityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AssertStateType defines an enumeration of assertion state types. */
export enum AssertStateType {
  /** ASSERT_STATE_UNSPECIFIED - Invalid Assert type. */
  ASSERT_STATE_UNSPECIFIED = 0,
  /** ASSERT_STATE_UNKNOWN - Assertion state is unknown, note this is not the same as UNSPECIFIED as it can be a valid state. */
  ASSERT_STATE_UNKNOWN = 1,
  /** ASSERT_STATE_TRUE - Assertion state is true. */
  ASSERT_STATE_TRUE = 2,
  /** ASSERT_STATE_FALSE - Assertion state is false. */
  ASSERT_STATE_FALSE = 3,
  UNRECOGNIZED = -1,
}

export function assertStateTypeFromJSON(object: any): AssertStateType {
  switch (object) {
    case 0:
    case "ASSERT_STATE_UNSPECIFIED":
      return AssertStateType.ASSERT_STATE_UNSPECIFIED;
    case 1:
    case "ASSERT_STATE_UNKNOWN":
      return AssertStateType.ASSERT_STATE_UNKNOWN;
    case 2:
    case "ASSERT_STATE_TRUE":
      return AssertStateType.ASSERT_STATE_TRUE;
    case 3:
    case "ASSERT_STATE_FALSE":
      return AssertStateType.ASSERT_STATE_FALSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssertStateType.UNRECOGNIZED;
  }
}

export function assertStateTypeToJSON(object: AssertStateType): string {
  switch (object) {
    case AssertStateType.ASSERT_STATE_UNSPECIFIED:
      return "ASSERT_STATE_UNSPECIFIED";
    case AssertStateType.ASSERT_STATE_UNKNOWN:
      return "ASSERT_STATE_UNKNOWN";
    case AssertStateType.ASSERT_STATE_TRUE:
      return "ASSERT_STATE_TRUE";
    case AssertStateType.ASSERT_STATE_FALSE:
      return "ASSERT_STATE_FALSE";
    case AssertStateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
